import React, { useEffect, useMemo, useState } from 'react'
import { Card, PageTitle, SearchField, StatusBadge, formatDate } from '../components/Ui'
import { adminRequest } from '../api/client'

function normalizeAdminPortfolio(item) {
  return {
    ...item,
    coverImageId: item.coverImageId || item.coverMediaId || null,
  }
}

export default function UserContentManagement({ type, navigate }) {
  const isPortfolio = type === 'portfolios'
  const [items, setItems] = useState([])
  const [search, setSearch] = useState('')
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState('')

  useEffect(() => {
    let disposed = false
    const path = isPortfolio ? '/api/v1/admin/managed-portfolios' : '/api/v1/admin/reviews'
    adminRequest(path)
      .then((response) => {
        if (disposed) return
        const data = Array.isArray(response?.data) ? response.data : []
        setItems(isPortfolio ? data.map(normalizeAdminPortfolio) : data)
      })
      .catch((loadError) => { if (!disposed) setError(loadError?.message || '콘텐츠 정보를 불러오지 못했습니다.') })
      .finally(() => { if (!disposed) setLoading(false) })
    return () => { disposed = true }
  }, [isPortfolio])

  const rows = useMemo(() => items.filter((item) => {
    const haystack = isPortfolio
      ? [item.title, item.directorName, ...(item.categories || []).map((entry) => entry.name), ...(item.tags || [])].join(' ')
      : [item.reviewerName, item.directorName, item.orderNo, item.headline, item.content].join(' ')
    return !search || haystack.toLowerCase().includes(search.toLowerCase())
  }), [items, search, isPortfolio])

  return <>
    <PageTitle eyebrow={isPortfolio ? 'DIRECTOR CONTENT' : 'MEMBER CONTENT'} title={isPortfolio ? '디렉터 포트폴리오 조회' : '이용자 후기·신고'} description={isPortfolio ? '디렉터가 실제 계정으로 등록하고 director_id로 연결된 포트폴리오를 조회합니다. 관리자가 포트폴리오를 대신 생성하지 않습니다.' : '실제 거래 이용자가 작성하고 회원·주문·디렉터와 연결된 후기를 조회합니다. 관리자가 후기를 새로 작성하지 않습니다.'} actions={<button className="button soft" onClick={() => navigate('/content/moderation')}>블라인드·삭제 관리</button>} />
    <div className="admin-section-callout"><div><strong>{isPortfolio ? '등록 주체: 디렉터' : '등록 주체: 이용자'}</strong><span>현재 목록은 localStorage나 Mock이 아니라 동일한 difan DEV DB 관계를 직접 조회합니다.</span></div><span className="admin-owner-label">조회·사후관리</span></div>
    {error && <div className="admin-notice"><strong>오류</strong><span>{error}</span></div>}
    <Card className="table-card">
      <div className="table-toolbar"><SearchField value={search} onChange={setSearch} placeholder={isPortfolio ? '포트폴리오명, 디렉터, 카테고리 검색' : '작성자, 디렉터, 주문번호, 후기 검색'} /></div>
      <div className="table-result-bar"><span>검색 결과 <strong>{rows.length}</strong>건</span><small>행을 선택하면 실제 연결 정보를 확인합니다.</small></div>
      <div className="table-scroll"><table className="data-table"><thead><tr>{isPortfolio ? ['포트폴리오','디렉터','카테고리','미디어','공개 권한','노출 상태','수정일'].map((label)=><th key={label}>{label}</th>) : ['작성자 / 주문','디렉터','평점','이미지','노출 상태','작성일'].map((label)=><th key={label}>{label}</th>)}</tr></thead><tbody>
        {loading ? <tr><td colSpan={isPortfolio ? 7 : 6}>실제 콘텐츠를 불러오는 중입니다.</td></tr> : rows.length ? rows.map((item) => isPortfolio
          ? <tr className="clickable-row" key={item.id} onClick={() => navigate(`/content/portfolios/${item.id}`)}><td><strong>{item.title}</strong><small>{item.id}{item.coverImageId ? ' · 대표 이미지 연결' : ''}</small></td><td>{item.directorName}</td><td>{(item.categories || []).map((entry)=>entry.name).join(' · ') || '-'}</td><td>{item.mediaCount}개</td><td>{item.rightsConfirmed ? '확인' : '확인 필요'}</td><td><StatusBadge status={item.publicationStatus} /></td><td>{formatDate(item.updatedAt, true)}</td></tr>
          : <tr className="clickable-row" key={item.id} onClick={() => navigate(`/content/reviews/${item.id}`)}><td><strong>{item.reviewerName}</strong><small>{item.orderNo}</small></td><td>{item.directorName}</td><td>{'★'.repeat(item.rating)} <small>{item.rating}.0</small></td><td>{item.mediaCount}개</td><td><StatusBadge status={item.status} /></td><td>{formatDate(item.createdAt, true)}</td></tr>) : <tr><td colSpan={isPortfolio ? 7 : 6}>{isPortfolio ? '등록된 포트폴리오가 없습니다.' : '등록된 후기가 없습니다.'}</td></tr>}
      </tbody></table></div>
    </Card>
  </>
}
